<ng-container *ngIf="detailHeaderSubject | async as detail">
  <ng-container [ngSwitch]="detail.status_enum">
    <ng-container *ngSwitchCase="DistributorStatusEnum.PENDING_EDIT_VERIFICATION" [ngTemplateOutlet]="adminViewTpl"></ng-container>
    <ng-container *ngSwitchCase="DistributorStatusEnum.PENDING_EDIT_VERIFICATION_FINANCE" [ngTemplateOutlet]="financeViewTpl"></ng-container>
  </ng-container>
</ng-container>

<ng-template #adminViewTpl>
  <app-note-view
    *ngIf="isPendingVerification"
    [classNoteView]="'mt-7'"
    [color]="'info'"
    [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION"
    [text]="'Perubahan data yang diajukan ditandai dengan warna biru. Silakan periksa dan selesaikan proses approval pengajuan data.'"
  />

  <ng-container *ngIf="distributorService.DistributorDetailHeader.is_change_sub_area" [ngTemplateOutlet]="onlyChangeSubArea"></ng-container>
  <ng-container *ngIf="!distributorService.DistributorDetailHeader.is_change_sub_area" [ngTemplateOutlet]="withStepper"></ng-container>

  <ng-template #onlyChangeSubArea>
    <div class="mt-7">
      <app-distributor-data [form]="distributorDataForm" [isOnlyChangeSubArea]="true"></app-distributor-data>
    </div>
    <div class="d-flex justify-content-between align-items-center">
      <button (click)="handleConfirm()" *ngIf="showButtonGroup()" [class]="'btn btn-primary min-w-150px ms-auto'" [disabled]="distributorDataForm.invalid">Konfirmasi</button>
    </div>
  </ng-template>

  <ng-template #withStepper>
    <mat-stepper #stepper (selectionChange)="onStepChange($event)" [animationDuration]="'150'" [disableRipple]="true" [linear]="true" class="my-0">
      <!--  STEP 1 - DATA DISTRIBUTOR -->
      <mat-step [state]="activeStepIndex === 0 ? 'edit' : 'number'" [stepControl]="distributorDataForm" label="Data Distributor">
        <ng-container *ngIf="activeStepIndex === 0">
          <app-distributor-data [form]="distributorDataForm"></app-distributor-data>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: distributorDataForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 2 - DATA USAHA -->
      <mat-step [state]="activeStepIndex === 1 ? 'edit' : 'number'" [stepControl]="businessDataForm" label="Data Usaha">
        <ng-container *ngIf="activeStepIndex === 1">
          <app-business-data #businessDataRef [form]="businessDataForm"></app-business-data>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: businessDataForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 3 - ALAMAT PENGIRIMAN -->
      <mat-step [state]="activeStepIndex === 2 ? 'edit' : 'number'" [stepControl]="shippingAddressForm" label="Alamat Pengiriman">
        <ng-container *ngIf="activeStepIndex === 2">
          <app-shipping-address [form]="shippingAddressForm"></app-shipping-address>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: shippingAddressForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <!--  STEP 5 - DOKUMEN -->
      <mat-step [state]="activeStepIndex === 3 ? 'edit' : 'number'" [stepControl]="documentForm" label="Dokumen">
        <ng-container *ngIf="activeStepIndex === 3">
          <app-document [form]="documentForm" [status]="detailHeaderSubject.value.status_enum"></app-document>
          <ng-container *ngTemplateOutlet="btnStepTpl; context: { isValid: documentForm.valid, i: activeStepIndex }" />
        </ng-container>
      </mat-step>

      <ng-template #btnStepTpl let-index="i" let-isValid="isValid">
        <div class="d-flex justify-content-between align-items-center">
          <button *ngIf="index !== 0" [class]="'btn btn-outline text-primary min-w-150px'" matStepperPrevious>Sebelumnya</button>
          <button
            (click)="index === 3 ? handleConfirm() : stepper.next()"
            *ngIf="index < 3 || (index === 3 && showButtonGroup())"
            [class]="'btn btn-primary min-w-150px' + (index === 0 ? ' ms-auto' : '')"
            [disabled]="!isValid"
          >
            {{ index === 3 ? 'Konfirmasi' : 'Selanjutnya' }}
          </button>
        </div>
      </ng-template>
    </mat-stepper>
  </ng-template>
</ng-template>

<ng-template #financeViewTpl>
  <mat-tab-group (selectedIndexChange)="handleTabChange($event)" [(selectedIndex)]="tabIndex" class="line mt-8" mat-stretch-tabs="false">
    <ng-container *ngFor="let tab of tabList; index as i">
      <mat-tab *ngIf="tab['privilege']" [label]="utilities.mapKeyToString(TabListLabelDetailDistributor, tab['labelKey'])">
        <ng-container *ngIf="i === tabIndex && tab.component">
          <ng-container *ngComponentOutlet="tab.component"></ng-container>
        </ng-container>
      </mat-tab>
    </ng-container>
  </mat-tab-group>
</ng-template>

<app-modal #modalConfirmVerification [modalConfig]="modalConfigConfirmVerification" [modalOptions]="{ size: 'md' }">
  <ng-container>
    <span>Apakah anda yakin mengonfirmasi Distributor:</span>
    <div class="my-4">
      <div class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">Nama Distributor</div>
        <div>: {{ detailHeaderSubject.value.business_name }}</div>
      </div>
      <div class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">Cakupan</div>
        <div>: {{ detailHeaderSubject.value.sales_sub_area + ', ' + detailHeaderSubject.value.sales_area }}</div>
      </div>
      <div class="d-flex">
        <div class="min-w-200 text-gray-600">Regional Head</div>
        <div>: {{ detailHeaderSubject.value.regional_head_name }}</div>
      </div>
    </div>

    <div *ngIf="revisionNote.value.length <= 0">
      <ng-container *ngTemplateOutlet="showDescConfirmation() ? defaultVerifyConfirmText : toFinanceConfirmText" />
    </div>

    <ng-template #defaultVerifyConfirmText>
      Setelah dikonfirmasi, Distributor akan <span class="fw-bold">diperbarui</span>. Pastikan semua data telah lengkap dan benar.

      <ng-container *ngIf="distributorService.DistributorDetailHeader.is_change_sub_area && responseConfirmChangeSubArea.length">
        <app-note-view [classNoteView]="'mt-7'" [color]="'info'" [extraContent]="true" [icon]="STRING_CONSTANTS.ICON.IC_INFORMATION">
          <div>Setelah disetujui, Produk Eksklusif Distributor akan dihapus karena perubahan Sub Area Distributor:</div>
          <ul>
            <li *ngFor="let item of responseConfirmChangeSubArea">{{ item }}</li>
          </ul>
        </app-note-view>
      </ng-container>
    </ng-template>

    <ng-template #toFinanceConfirmText> Setelah dikonfirmasi, Distributor akan diteruskan ke Finance. Pastikan semua data telah lengkap dan benar. </ng-template>
  </ng-container>

  <ng-container *ngIf="revisionNote | async as revisionNote">
    <ng-container *ngIf="revisionNote.length > 0">
      <div class="d-flex my-4">
        <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER" class="svg-icon svg-icon-24"></span>
        <div class="ms-4 fw-bold">Catatan Perbaikan</div>
      </div>
      <div *ngFor="let item of revisionNote" class="mb-2 d-flex">
        <div class="min-w-200 text-gray-600">{{ item.label }}</div>
        <div>: {{ item.value }}</div>
      </div>
    </ng-container>
  </ng-container>
</app-modal>

<app-modal #modalSuccessResetPassword [modalConfig]="modalSuccessResetPasswordConfig">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT" class="mb-6"></span>
    <ng-container *ngIf="responseVerification | async as res">
      <div class="text-center">Pembaruan data distributor berhasil dikonfirmasi.</div>
      <div class="text-center">Akses login distributor {{ detailHeaderSubject.value.business_name }}:</div>
      <div class="group_user_password">
        <div class="mt-5 d-flex flex-column w-100 justify-content-center on_copy_password align-items-center">
          <strong class="text-center">{{ res.distributor_email }}</strong>
          <div class="d-flex gap-2">
            <strong class="text-center">{{ res.distributor_password }}</strong>
            <div class="d-flex" ngbPopover="Password berhasil di copy" placement="top">
              <span (click)="utilities.copyToClipboard(res.distributor_password)" [inlineSVG]="STRING_CONSTANTS.ICON.IC_COPY" class="cursor-pointer"></span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="mt-4 p-3 d-flex align-items-center rounded justify-content-between bg-gray-100">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFO"></span>
    <div class="fs-8">Pastikan password berhasil dicopy sebelum menutup pop up.</div>
  </div>
</app-modal>

<app-modal #modalResponse [modalConfig]="modalResponseConfig" [modalOptions]="{ size: 'md' }">
  <div class="d-flex flex-column justify-content-center align-items-center">
    <span [inlineSVG]="STRING_CONSTANTS.ICON.SUCCESS_ALERT" class="mb-6"></span>
    <div class="text-center">{{ generateDescSuccess() }}</div>
  </div>
</app-modal>
